<template>
    <div class="notification" :class="notificationClass" v-if="showNotification">
        <template v-if="isTranslated">{{ getTranslatedText(message) }}</template>
        <span v-else v-html="message"></span>
    </div>
</template>

<script>
import languageMixins from '@/mixins/language/language-mixins'

export default {
    mixins: [languageMixins],

    data() {
        return {
            showNotification: false,
            message: '',
            notificationClass: '',
            isTranslated: true,
        }
    },
    methods: {
        showSuccessNotification(message, isTranslated = true) {
            this.showNotification = true
            this.message = message
            this.isTranslated = isTranslated
            this.notificationClass = 'success'

            setTimeout(() => {
                this.hideNotification()
            }, 2000)
        },
        showErrorNotification(message, isTranslated = true) {
            this.showNotification = true
            this.message = message
            this.isTranslated = isTranslated
            this.notificationClass = 'error'

            setTimeout(() => {
                this.hideNotification()
            }, 2000)
        },

        showWarningNotification(message, isTranslated = true) {
            this.showNotification = true
            this.message = message
            this.isTranslated = isTranslated
            this.notificationClass = 'warning'

            setTimeout(() => {
                this.hideNotification()
            }, 2000)
        },

        hideNotification() {
            this.showNotification = false
            this.message = ''
            this.notificationClass = ''
            this.isTranslated = true
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/common/notifi/index.scss';
</style>
